/** PREREQ Stage 8.9 — Collection card quick add. */
(() => {
  class PrereqQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.dataset.prereqQuickAddReady === 'true') return;
      this.dataset.prereqQuickAddReady = 'true';
      this.form = this.querySelector('[data-quick-add-form]');
      this.submit = this.querySelector('[data-quick-add-submit]');
      this.label = this.querySelector('[data-quick-add-label]');
      this.message = this.querySelector('[data-quick-add-message]');
      this.defaultLabel = this.label?.textContent?.trim() || 'Add to cart';
      this.isSubmitting = false;
      this.form?.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    setMessage(message = '', isError = false) {
      if (!this.message) return;
      this.message.textContent = message;
      this.message.hidden = !message;
      this.message.classList.toggle('is-error', isError);
    }

    setSubmitting(submitting) {
      this.isSubmitting = submitting;
      if (this.submit) this.submit.disabled = submitting;
      this.submit?.setAttribute('aria-busy', submitting ? 'true' : 'false');
      if (this.label) this.label.textContent = submitting ? 'Adding…' : this.defaultLabel;
    }

    handleSubmit = async (event) => {
      event.preventDefault();
      if (!this.form || this.isSubmitting) return;

      this.setMessage('');
      this.setSubmitting(true);

      try {
        const action = new URL(this.form.action, window.location.origin);
        action.pathname = action.pathname.replace(/\/$/, '') + '.js';

        const response = await fetch(action.toString(), {
          method: 'POST',
          body: new FormData(this.form),
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Unable to add this item to your cart.');
        }

        await this.refreshAndOpenCartDrawer();
        const quantity = this.form.querySelector('input[name="quantity"]');
        if (quantity) quantity.value = '1';
        this.setMessage('Added to cart.');
      } catch (error) {
        console.error('[PREREQ] Quick add failed', error);
        this.setMessage(error.message || 'Unable to add this item to your cart. Please try again.', true);
      } finally {
        this.setSubmitting(false);
      }
    };

    async refreshAndOpenCartDrawer() {
      const headerRoot = document.querySelector('[data-prereq-header]');
      const headerSection = headerRoot?.closest('.shopify-section');
      const sectionDomId = headerSection?.id || '';
      const sectionId = sectionDomId.replace(/^shopify-section-/, '');

      if (!headerSection || !sectionId) {
        window.location.reload();
        return;
      }

      const sectionUrl = new URL(window.location.href);
      sectionUrl.search = '';
      sectionUrl.hash = '';
      sectionUrl.searchParams.set('section_id', sectionId);

      const sectionResponse = await fetch(sectionUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!sectionResponse.ok) throw new Error('Item was added, but the cart drawer could not be refreshed.');
      const html = await sectionResponse.text();
      if (!html.trim()) throw new Error('Item was added, but the cart drawer could not be refreshed.');

      headerRoot?.prereqHeaderController?.destroy?.();
      headerSection.innerHTML = html;
      headerSection.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

      requestAnimationFrame(() => {
        headerSection.querySelector('[data-prereq-cart-open]')?.click();
      });
    }
  }

  if (!customElements.get('prereq-quick-add')) {
    customElements.define('prereq-quick-add', PrereqQuickAdd);
  }
})();
